import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalPageHeaderComponent } from '../../global-page-header/global-page-header.component';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-larged-link',
  templateUrl: './larged-link.component.html',
  styleUrls: ['./larged-link.component.scss'],
  standalone: true,
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    IonFooter,
    IonItem,
    IonLabel,
    IonList,
    IonModal,
    TranslatePipe,
  ],
})
export class LargedLinkComponent {
  @Input() title?: string;
  @Input() name: string = '';
  @Input() textBeforeArrow: string = '';
  @Input() picto: string = 'fa-chevron-right';
  @Input() namedList: any[] = [];
  @Input() description?: string;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onPress = new EventEmitter<any>();

  constructor() {}

  onElementClick() {
    this.onPress.emit();
  }
}
